<template>
  <div>
    <el-row :gutter="20">
      <!-- 左侧：状态列表 -->
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="handleStateSelect('')"
              :class="{ 'selected': allocationOrderManageInfo.conditions.state === '' }">
              全部
            </li>
            <li v-for="(item, index) in allocationOrderManageInfo.states" :key="index"
              @click="handleStateSelect(item.statusCd)"
              :class="{ 'selected': allocationOrderManageInfo.conditions.state === item.statusCd }">
              {{ item.name }}
            </li>
          </ul>
        </el-card>
      </el-col>

      <!-- 右侧：查询条件和表格 -->
      <el-col :span="21">
        <!-- 查询条件 -->
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('allocationOrder.queryCondition') }}</div>
            <div class="ibox-tools" style="top:10px;">
            </div>
          </div>
          <div class="">
            <el-form :inline="true" :model="allocationOrderManageInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-form-item>
                  <el-input v-model="allocationOrderManageInfo.conditions.orderId"
                    :placeholder="$t('allocationOrder.inputOrderId')" clearable />
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-form-item>
                  <el-select v-model="allocationOrderManageInfo.conditions.srcShId"
                    :placeholder="$t('allocationOrder.selectSrcWarehouse')" style="width:100%" clearable>
                    <el-option v-for="(item, index) in allocationOrderManageInfo.shopHouses" :key="index"
                      :label="item.shName" :value="item.shId" />
                  </el-select>
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-form-item>
                  <el-select v-model="allocationOrderManageInfo.conditions.targetShId"
                    :placeholder="$t('allocationOrder.selectTargetWarehouse')" style="width:100%" clearable>
                    <el-option v-for="(item, index) in allocationOrderManageInfo.shopHouses" :key="index"
                      :label="item.shName" :value="item.shId" />
                  </el-select>
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="allocationOrderManageInfo.conditions.queryStartTime"
                  type="date"
                  placeholder="开始时间"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="allocationOrderManageInfo.conditions.queryEndTime"
                  type="date"
                  placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item>
                  <el-button type="primary" size="small" @click="_queryAssetInventoryMethod()">
                    <i class="el-icon-search"></i> {{ $t('common.query') }}
                  </el-button>
                  <el-button type="primary" size="small" @click="_resetAssetInventoryMethod()">
                    <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
                  </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <!-- 调拨单表格 -->
        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('allocationOrder.assetAllocation') }}</div>
            <div class="ibox-tools" style="top:10px;">
              <el-button type="primary" size="small" @click="_openAddAssetInventoryModal()">
                <i class="el-icon-plus"></i> {{ $t('allocationOrder.allocation') }}
              </el-button>
            </div>
          </div>
          <div class="">
            <el-table :data="allocationOrderManageInfo.allocationOrders" border style="width: 100%">
              <el-table-column prop="orderId" :label="$t('allocationOrder.orderId')" align="center" />
              <el-table-column prop="prodName" :label="$t('allocationOrder.productName')" align="center" />
              <el-table-column prop="specName" :label="$t('allocationOrder.specName')" align="center" />
              <el-table-column prop="shopName" :label="$t('allocationOrder.srcShop')" align="center" />
              <el-table-column prop="srcShName" :label="$t('allocationOrder.srcWarehouse')" align="center" />
              <el-table-column prop="targetShopName" :label="$t('allocationOrder.targetShop')" align="center" />
              <el-table-column prop="targetShName" :label="$t('allocationOrder.targetWarehouse')" align="center" />
              <el-table-column prop="productCount" :label="$t('allocationOrder.productCount')" align="center" />
              <el-table-column prop="staffName" :label="$t('allocationOrder.allocationPerson')" align="center" />
              <el-table-column prop="stateName" :label="$t('allocationOrder.status')" align="center" />
              <el-table-column prop="createTime" :label="$t('allocationOrder.allocationTime')" align="center" />
              <el-table-column :label="$t('common.operation')" align="center" width="200">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.state === '1001'" type="text" size="small"
                    @click="_openInStockAssetInventoryModel(scope.row)">
                    {{ $t('allocationOrder.audit') }}
                  </el-button>
                  <el-button v-if="scope.row.state === '1001'" type="text" size="small"
                    @click="_openEditAssetInventoryModel(scope.row)">
                    {{ $t('common.edit') }}
                  </el-button>
                  <el-button v-if="scope.row.state === '1001'" type="text" size="small"
                    @click="_openDeleteAssetInventoryModel(scope.row)">
                    {{ $t('common.delete') }}
                  </el-button>
                  <el-button v-if="scope.row.state === '2002'" type="text" size="small"
                    @click="_doAllocationOrderInModel(scope.row)">
                    {{ $t('allocationOrder.inStock') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination :current-page="allocationOrderManageInfo.conditions.page" :page-sizes="[10, 20, 30, 50]"
              :page-size="allocationOrderManageInfo.conditions.row" layout="total, sizes, prev, pager, next, jumper"
              :total="allocationOrderManageInfo.total" @size-change="handleSizeChange"
              @current-change="handleCurrentChange" />
          </div>
        </el-card>
      </el-col>
    </el-row>

    <delete-asset-inventory ref="deleteAssetInventory" />
    <allocation-order-edit ref="allocationOrderEdit" />
    <delete-allocation-order ref="deleteAllocationOrder" />
    <allocation-order-audit ref="allocationOrderAudit" @refresh="_refreshList" />
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryAllocationOrder, listShopHouses } from '@/api/goods/allocationOrderApi'
import DeleteAssetInventory from '@/components/goods/deleteAssetInventory/deleteAssetInventory.vue'
import AllocationOrderEdit from '@/components/goods/allocationOrderEdit/allocationOrderEdit.vue'
import DeleteAllocationOrder from '@/components/goods/deleteAllocationOrder/deleteAllocationOrder.vue'
import AllocationOrderAudit from '@/components/goods/allocationOrderAudit/allocationOrderAudit.vue'

export default {
  name: 'AllocationOrderManage',
  components: {
    DeleteAssetInventory,
    AllocationOrderEdit,
    DeleteAllocationOrder,
    AllocationOrderAudit
  },
  data() {
    return {
      allocationOrderManageInfo: {
        allocationOrders: [],
        shopHouses: [],
        total: 0,
        records: 1,
        moreCondition: false,
        aiId: '',
        curOrder: {},
        states: [],
        conditions: {
          shId: '',
          orderId: '',
          srcShId: '',
          targetShId: '',
          staffName: '',
          state: '',
          shopId: '',
          queryStartTime: '',
          queryEndTime: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    _initMethod() {
      this._listShopHouses()
      this._listAssetInventorys(1, 10)
      this.getDictData()
    },
    async getDictData() {
      try {
        const res = await getDict('allocation_order', 'state')
        this.allocationOrderManageInfo.states = res.data || []
        console.log('状态字典数据:', this.allocationOrderManageInfo.states)
      } catch (error) {
        console.error('获取字典数据失败:', error)
        this.$message.error('获取状态字典失败')
      }
    },
    handleSizeChange(val) {
      this.allocationOrderManageInfo.conditions.row = val
      this._listAssetInventorys(this.allocationOrderManageInfo.conditions.page, val)
    },
    handleCurrentChange(val) {
      this._listAssetInventorys(val, this.allocationOrderManageInfo.conditions.row)
    },
    async _listAssetInventorys(page, rows) {
      this.allocationOrderManageInfo.conditions.page = page
      this.allocationOrderManageInfo.conditions.row = rows
      this.allocationOrderManageInfo.conditions.shopId = getShopId()

      try {
        const res = await queryAllocationOrder(this.allocationOrderManageInfo.conditions)
        this.allocationOrderManageInfo.total = res.total
        this.allocationOrderManageInfo.records = res.records
        this.allocationOrderManageInfo.allocationOrders = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openAddAssetInventoryModal() {
      this.$router.push('/pages/goods/allocationOrderIn')
    },
    _openEditAssetInventoryModel(allocationOrder) {
      this.$refs.allocationOrderEdit.open(allocationOrder)
    },
    _doAllocationOrderInModel(inoutOrder) {
      this.$router.push({
        path: '/pages/goods/doAllocationOrderIn',
        query: {
          orderId: inoutOrder.orderId
        }
      })
    },
    _openInStockAssetInventoryModel(order) {
      this.$refs.allocationOrderAudit.open(order)
    },
    _openDeleteAssetInventoryModel(allocationOrder) {
      this.$refs.deleteAllocationOrder.open(allocationOrder)
    },
    _queryAssetInventoryMethod() {
      this._listAssetInventorys(1, this.allocationOrderManageInfo.conditions.row)
    },
    _resetAssetInventoryMethod() {
      this.allocationOrderManageInfo.conditions.orderId = ''
      this.allocationOrderManageInfo.conditions.srcShId = ''
      this.allocationOrderManageInfo.conditions.targetShId = ''
      this.allocationOrderManageInfo.conditions.queryStartTime = ''
      this.allocationOrderManageInfo.conditions.queryEndTime = ''
      this._listAssetInventorys(1, this.allocationOrderManageInfo.conditions.row)
    },
    handleStateSelect(state) {
      this.allocationOrderManageInfo.conditions.state = state
      this.allocationOrderManageInfo.conditions.page = 1
      this._listAssetInventorys(1, this.allocationOrderManageInfo.conditions.row)
    },
    _moreCondition() {
      this.allocationOrderManageInfo.moreCondition = !this.allocationOrderManageInfo.moreCondition
    },
    async _listShopHouses() {
      try {
        const res = await listShopHouses({
          page: 1,
          row: 100,
          shopId: getShopId()
        })
        this.allocationOrderManageInfo.shopHouses = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _refreshList() {
      this._listAssetInventorys(this.allocationOrderManageInfo.conditions.page, this.allocationOrderManageInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.margin-top-sm {
  margin-top: 20px;
}
</style>